<!-- prettier-ignore -->   

<button
  hammerLongPress
  type="button"
  class="chat__button"
  [attr.aria-label]="isRecording()
    ? ('Finalizar grabación de voz' | translate)
    : ('Grabar mensaje de voz' | translate)"
  [class.is_stop]="isPlayingWelcome() && isRecording()"
  [class.is_recording]="showRecordIcon() && isRecording()" 
  [class.is_ready_to_send]="isRecording() && !isPlayingWelcome()"
  (shortTap)="onShortTap()"
  (longPressStart)="onLongPressStart()"
  (longPressEnd)="onLongPressEnd()"
>
  
  @if(showRecordIcon() && isRecording()){
    <icon-pulse />
    
  } @else if(isRecording() && isPlayingWelcome()){
    <cancel-button />
  } @else if(isRecording() && !isPlayingWelcome()){
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
      <path d="M5.33366 11.3333V3.21663L1.60033 6.94996L0.666992 5.99996L6.00033 0.666626L11.3337 5.99996L10.4003 6.94996L6.66699 3.21663V11.3333H5.33366Z" fill="currentColor"></path>
    </svg>
    <span class="ci-paragraph-p1-regular">
      {{ 'Finalizar' | translate }}
    </span>
  } @else if (isPlayingWelcome()) {
    <loader-button />
  } @else{
    <icon-voice />
  }
</button>
